import React, { useEffect, useState } from 'react'
import {Modal, Form, Button, Alert, Row, Col} from 'react-bootstrap';
import Input from './Input';
import { verifyCode,get_verify_code } from '../api.js'

function ModalVerifyCode(props) {

  const [code,set_code] = useState(0);
  const [isValid,set_is_valid] = useState(false);
  const [is_invalid,set_is_invalid] = useState(false);
  const [message_error,set_message_error] = useState({show:false,message:""});
  const [email,set_email] = useState("");
  const [title_reenviar,set_title_reenviar] = useState("Reenviar Código de Verificación");
  const [input_disabled,set_input_disabled] = useState(true);
  const [await_time,set_await_time] = useState(0);

  const handle_change = (value,isValid)=>{
  
    set_code(value);
    set_is_valid(isValid);
    set_is_invalid(!isValid)

  }

  function cuentaRegresiva(seconds,set_state) {

    return new Promise((resolve) => {

      set_input_disabled(true);
      const intervalo = setInterval(() => {
        if (seconds > 0) {
          set_state(`Reenviar Código Verificación (${seconds}s)`);
          seconds--;
        } else {
          clearInterval(intervalo);
          set_state(`Reenviar Código de Verificación`);
          set_input_disabled(false);
          resolve('¡Cuenta regresiva finalizada!');
        }
      }, 1000); // Actualiza cada segundo
    });
  }

  const handle_onCode = () =>{

    verifyCode(code,email).then(()=> {
      props.onSuccess(true);
    })
    .catch(err =>{
      set_is_valid(false); set_is_invalid(true); set_message_error({show:true,message:err.message})
    })

    
    // submit(form.target, { method: "post", action: "/verifyCode" });
    
  }

  const hanbled_send_code = () =>{

    get_verify_code(email).then(()=>{

      cuentaRegresiva(await_time,set_title_reenviar)
      .then(mensaje => {
        console.log(mensaje);
      })
      .catch(error => {
        console.error('Error:', error);
      });

    })
    .catch((exp) =>{
      console.log(exp);

      set_message_error(exp.message);
      cuentaRegresiva(exp.seconds,set_title_reenviar)
      .then(mensaje => {
        console.log(mensaje);
      })
      .catch(error => {
        console.error('Error:', error);
      });

    });
  }

  useEffect(()=>{

    cuentaRegresiva(await_time,set_title_reenviar)

  },[await_time]);

  useEffect(()=>{

    set_await_time(props.await_time);
    
  },[props]);

  useEffect(()=>{

    if(props.email !== undefined){
      // console.log(props.email);
      set_email(props.email);
    }
    
      
  },[props]);

  return (
    <>
        <Modal
      onHide = {props.onHide}
      show = {props.show}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
        Introduce el código de verificación
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className='m-3'>
        {/* <h4 className='text-center mb-3'></h4> */}
        <p className='mb-3' style={{
          "textAlign" : "justify",
          "fontSize"  : "15px"
        }}>
          Acabamos de enviar a tu correo electrónico <strong>{email}</strong> un código de verificación de 6 digitos.
        </p>

        <p className='mb-4' style={{
          "textAlign" : "justify",
          "fontSize"  : "15px"
        }}>
          Si el correo no se encuentra en su carpeta de entrada, recuerde revisar su carpeta de spam.
        </p>
        <Form id='frmVerifyCode'>

          <Row className='justify-content-center'>
            <Col sm = "8" md = "8" lg = "8">
              <Input 
                key             = { 'code' } 
                id              = { `txtcode` }
                name            = { 'code' } 
                type            = { 'text' }
                label           = { 'Código Verificación' } 
                placeholder     = { 'Ingrese el código de verificación' } 
                required        = { true } 
                min             = { 6 }
                max             = { 6 }
                message         = { 'Código Invalido' }
                isInvalid       = { is_invalid }
                isValid         = { isValid }
                onChange        = { (e,isValid) => handle_change(e.target.value,isValid) }
                // onBlur          = { (e) => hanble_blur(index) }
                // onCheckValidity = { (valid) =>  handle_valid(index,valid) }
            />
            </Col>
          </Row>
        </Form>

        <Row style={{display:message_error.show ? "inline" : "none"}}>
                <Col>
                    <Alert style={{
                        "fontSize":"12px",
                        "backgroundColor": "#dc3545",
                        "color" : "white",
                    }} variant={'danger'}>{message_error.message}</Alert>
                </Col>
        </Row>
        <Row className='justify-content-center mt-4'>
          <Col sm="12" md="12" lg="12">
          
          {/* <button type="button" disabled={input_disabled} className="btn btn-outline-primary" onClick={hanbled_send_code} style={{"display":"table","marginLeft":"auto","marginRight":"auto"}}>{title_reenviar}</button> */}

            {/* <a href="" className='text-center mb-4' style={{marginLeft:"auto",marginRight:"auto"}}>Reenviar Código de Verificación</a> */}
          </Col>
        </Row>
        
      </Modal.Body>
      <Modal.Footer>
        <button type="button" disabled={input_disabled} className="btn btn-outline-primary" onClick={hanbled_send_code}>{title_reenviar}</button>

        <Button disabled={!isValid} onClick={handle_onCode}>Confirmar Código</Button>
      </Modal.Footer>
    </Modal>
    </>
  )
}

export default ModalVerifyCode